import { render, staticRenderFns } from "./crm-create-new.vue?vue&type=template&id=ddf61d80&scoped=true&"
import script from "./crm-create-new.vue?vue&type=script&lang=js&"
export * from "./crm-create-new.vue?vue&type=script&lang=js&"
import style0 from "./crm-create-new.vue?vue&type=style&index=0&id=ddf61d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf61d80",
  null
  
)

export default component.exports